import {
  AGENCY_PRERENDER_JOB_STATUS,
  ACTIVE_PRERENDER_JOB_STATUSES
} from './constants'

export function formatPrerenderTimestamp(iso) {
  if (!iso) return '—'
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso
  return date.toLocaleString()
}

export function summarizeFormats(formats, whitelabelEligible) {
  if (!formats?.length) return '—'
  const parts = formats.map((entry) => {
    const def = entry.defaultExists ? 'D✓' : 'D✗'
    if (!whitelabelEligible) {
      return `${entry.format.toUpperCase()} ${def}`
    }
    const wl = entry.whitelabelExists ? 'WL✓' : 'WL✗'
    return `${entry.format.toUpperCase()} ${def} ${wl}`
  })
  return parts.join(' · ')
}

export function matchesAgencyPrerenderSearch(row, term) {
  const haystack = [
    row.libraryFileName,
    row.documentFileName,
    row.libraryCategoryName,
    row.itemId
  ].join(' ').toLowerCase()
  return haystack.includes(term)
}

export function pickAgencyJob(jobs, agencyId) {
  const prefix = `${agencyId}__`
  const matches = Object.entries(jobs || {})
    .filter(([jobKey]) => jobKey.startsWith(prefix))
    .map(([jobKey, job]) => ({ jobKey, ...job }))

  if (!matches.length) {
    return null
  }

  const active = matches.find((job) => ACTIVE_PRERENDER_JOB_STATUSES.has(job.status))
  if (active) {
    return active
  }

  return matches.sort((a, b) => (
    String(b.updatedAt || '').localeCompare(String(a.updatedAt || ''))
  ))[0]
}

function allFormatsPrerendered(formats, whitelabelEligible) {
  if (!formats?.length) {
    return false
  }
  return formats.every((entry) => {
    if (!entry.defaultExists) {
      return false
    }
    if (whitelabelEligible && !entry.whitelabelExists) {
      return false
    }
    return true
  })
}

export function deriveAgencyPrerenderDisplayStatus({ agencyJob, formats, whitelabelEligible }) {
  const complete = allFormatsPrerendered(formats, whitelabelEligible)

  if (agencyJob) {
    if (ACTIVE_PRERENDER_JOB_STATUSES.has(agencyJob.status)) {
      return { key: 'processing', label: 'Processing' }
    }
    if (agencyJob.status === AGENCY_PRERENDER_JOB_STATUS.FAILED) {
      return { key: 'failed', label: 'Failed' }
    }
    if (agencyJob.status === AGENCY_PRERENDER_JOB_STATUS.SKIPPED) {
      return { key: 'skipped', label: 'Skipped' }
    }
    if (agencyJob.status === AGENCY_PRERENDER_JOB_STATUS.PROCESSED) {
      return complete
        ? { key: 'ready', label: 'Ready' }
        : { key: 'incomplete', label: 'Incomplete' }
    }
  }

  if (complete) {
    return { key: 'ready', label: 'Ready' }
  }
  return { key: 'missing', label: 'Missing' }
}

export function isActivePrerenderJobStatus(status) {
  return ACTIVE_PRERENDER_JOB_STATUSES.has(status)
}
